"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var reducers_1 = require("../../reducers");
var CustomLabel_1 = require("./CustomLabel");
require("./Forms.scss");
require("./CustomDatePicker.scss");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var CustomDatePicker = function (props) {
    var className = props.className, readOnly = props.readOnly, currentLang = props.currentLang, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, containerClassName = props.containerClassName, isRequired = props.isRequired;
    var useClassName = clsx_1.default(className, readOnly ? 'eta-cDatePickerReadOnly' : '', currentLang.isRtl ? 'rtlFlag' : 'ltrFlag');
    var label = props.label;
    var t = react_i18next_1.useTranslation(['calendar']).t;
    var getdateformatting = function (locale) {
        return ({
            formatYear: function (d) { return d.toLocaleString(locale, { year: 'numeric' }); },
            formatDay: function (d) { return d.toLocaleString(locale, { day: 'numeric' }); },
            formatMonthDayYear: function (d) { return d.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' }); },
            formatMonthYear: function (d) { return d.toLocaleString(locale, { year: 'numeric', month: 'long' }); }
        });
    };
    var overrideDayPickerStrings = {
        months: [
            t('calendar:janFull'),
            t('calendar:febFull'),
            t('calendar:marFull'),
            t('calendar:aprFull'),
            t('calendar:mayFull'),
            t('calendar:juneFull'),
            t('calendar:julFull'),
            t('calendar:augFull'),
            t('calendar:sepFull'),
            t('calendar:octFull'),
            t('calendar:novFull'),
            t('calendar:decFull'),
        ],
        shortMonths: [t('calendar:janShort'), t('calendar:febShort'), t('calendar:marShort'), t('calendar:aprShort'),
            t('calendar:mayShort'), t('calendar:juneShort'), t('calendar:julShort'), t('calendar:augShort'), t('calendar:sepShort'),
            t('calendar:octShort'), t('calendar:novShort'), t('calendar:decShort')],
        days: [t('calendar:sunFull'), t('calendar:monFull'), t('calendar:tuesFull'), t('calendar:wedFull'), t('calendar:thurFull'),
            t('calendar:friFull'), t('calendar:satFull')],
        shortDays: [t('calendar:sunShort'), t('calendar:monShort'), t('calendar:tuesShort'), t('calendar:wedShort'),
            t('calendar:thurShort'), t('calendar:friShort'), t('calendar:satShort')],
        goToToday: t('calendar:goToToday'),
        prevMonthAriaLabel: t('calendar:prevMonth'),
        nextMonthAriaLabel: t('calendar:nextMonth'),
        prevYearAriaLabel: t('calendar:prevYear'),
        nextYearAriaLabel: t('calendar:nextYear'),
        closeButtonAriaLabel: t('calendar:closeButton')
    };
    var stringsOverride = currentLang.lang === 'ar' ? overrideDayPickerStrings : undefined;
    var dateTimeFormatterOverride = currentLang.lang === 'ar' ? getdateformatting(currentLang.langIso4) : undefined;
    return (react_1.default.createElement("div", { className: clsx_1.default('vertialFlexDiv', containerClassName) },
        label && (react_1.default.createElement(CustomLabel_1.Label, { required: isRequired, toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
        react_1.default.createElement(react_2.DatePicker, __assign({}, props, { isRequired: undefined, className: useClassName, label: undefined, strings: stringsOverride, dateTimeFormatter: dateTimeFormatterOverride }))));
};
exports.default = connector(CustomDatePicker);
//# sourceMappingURL=CustomDatePicker.js.map